import { render, staticRenderFns } from "./DetailedFund.vue?vue&type=template&id=1a4b7558&scoped=true"
import script from "./DetailedFund.vue?vue&type=script&lang=js"
export * from "./DetailedFund.vue?vue&type=script&lang=js"
import style0 from "./DetailedFund.vue?vue&type=style&index=0&id=1a4b7558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b7558",
  null
  
)

export default component.exports